import React, { useCallback, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import api, { fileUrl } from "../lib/api";
import { Radio } from "lucide-react";

/**
 * LiveRail — a horizontal rail of currently-live vendors. Auto-hides when empty.
 * Designed to sit under the Feed top nav. Small, glassy, and fast.
 */
export default function LiveRail({ inline = false }) {
  const [streams, setStreams] = useState([]);
  const navigate = useNavigate();

  const load = useCallback(async () => {
    try {
      const { data } = await api.get("/streams/live");
      setStreams(data);
    } catch { /* ignore */ }
  }, []);

  useEffect(() => {
    load();
    const i = setInterval(load, 30000);
    return () => clearInterval(i);
  }, [load]);

  if (streams.length === 0) return null;

  return (
    <div
      className={
        inline
          ? "px-3 py-2"
          : "fixed top-12 left-1/2 -translate-x-1/2 z-40 max-w-[92vw] px-3 py-2 rounded-2xl glass-strong"
      }
      data-testid="feed-live-rail"
    >
      <div className="flex items-center gap-2 overflow-x-auto no-scrollbar">
        <button
          onClick={() => navigate("/live")}
          className="shrink-0 inline-flex items-center gap-1.5 h-9 px-3 rounded-full bg-red-500 hover:bg-red-400 text-white text-[11px] font-black uppercase tracking-widest"
          data-testid="live-rail-cta"
        >
          <span className="w-1.5 h-1.5 rounded-full bg-white animate-ping" /> Live
        </button>
        {streams.slice(0, 12).map((s) => (
          <button
            key={s.stream_id}
            onClick={() => navigate(`/live/${s.stream_id}`)}
            className="shrink-0 group relative"
            data-testid={`live-rail-item-${s.stream_id}`}
            aria-label={`Watch ${s.vendor_name} live`}
          >
            <span className="block w-12 h-12 rounded-full border-2 border-red-500 overflow-hidden bg-zinc-800 ring-2 ring-red-500/40 animate-pulse">
              {s.vendor_avatar ? (
                <img src={fileUrl(s.vendor_avatar)} alt={s.vendor_name} className="w-full h-full object-cover" />
              ) : (
                <span className="w-full h-full grid place-items-center text-pink-200 font-black bg-pink-500/20">
                  {(s.vendor_name || "?")[0]}
                </span>
              )}
            </span>
            <span className="absolute -bottom-1 left-1/2 -translate-x-1/2 px-1 py-0 rounded-full bg-red-500 text-white text-[8px] font-black uppercase tracking-widest leading-none inline-flex items-center">
              <Radio className="w-2 h-2 mr-0.5" /> LIVE
            </span>
          </button>
        ))}
      </div>
    </div>
  );
}
